import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { verifyNonPartnerEmployerRequest } from 'tio-data/requests/pslf-form-actions';
import type { Store as StoreService } from '@warp-drive/core';
import type { EmployerFormInfo } from 'tio-employee/templates/pslf-employer/non-partner-sign';

export default class PslfEmployerNonPartnerSignRoute extends Route {
  @service declare store: StoreService;

  async model() {
    const params = this.paramsFor('pslf-employer') as { approval: string };

    // Legacy PslfFormAdapter#verifyNonPartnerEmployer POSTed
    // /pslf-forms/non-partner-employer/verify with { approvalId } and rethrew a
    // friendly Error on failure; preserve that error mapping here.
    let employerFormInfo: EmployerFormInfo;
    try {
      const response = await this.store.request<EmployerFormInfo>(
        verifyNonPartnerEmployerRequest(params.approval)
      );
      employerFormInfo = response.content;
    } catch (error) {
      if (error) {
        throw new Error('Bad request. Please check the employer data.', { cause: error });
      }
      throw new Error('An unexpected error occurred while verifying the non-partner employer.', {
        cause: error,
      });
    }

    return {
      employerFormInfo,
      approvalId: params.approval,
    };
  }
}
